import ReactDOM from "react-dom";

var node;
var modals = [];

const renderModal = () => {
  if (modals.length == 0) return;

  const component = modals.shift();
  if (!node) {
    node = document.createElement("div");
    document.body.appendChild(node);
  }
  ReactDOM.render(component, node);
};

export const ModalManager = {
  open(component) {
    modals.push(component);
    if (modals.length == 1) {
      renderModal();
    }
  },
  close() {
    ReactDOM.unmountComponentAtNode(node);
    renderModal();
  }
};
